import { attribute, clickable, collection, fillable, isPresent, isVisible, triggerable, value } from 'ember-cli-page-object';
import { isChecked } from 'vagrant/test-support/ecpo-utils';
export default (scope = '[data-test-provider-card]', properties = {}) => ({
  scope,
  name: value('input[name="name"]'),
  isExternal: isChecked('input[name^="provider-hosting"][value="external"]'),
  isHosted: isChecked('input[name^="provider-hosting"][value="hosted"]'),
  file: value('input[name="hostedFile"]'),
  externalUrl: value('input[name="externalUrl"]'),
  hostedFile: value('input[name="hostedFile"]'),
  checksumType: value('select[name="checksumType"]'),
  checksum: value('input[name="checksum"]'),
  architecture: value('select[name="architecture"]'),
  defaultForName: isChecked('input[name^="architecture-default"]'),
  hasWarning: isPresent('.hds-alert--color-warning'),
  hasSuccessDisclaimer: isPresent('.hds-alert--color-success.hds-alert--type-compact'),
  hasError: isVisible('.hds-form-error'),
  suggestedProviders: collection('datalist option'),
  suggestedProvidersId: attribute('id', 'datalist'),
  nameList: attribute('list', 'input[name="name"]'),
  fillInName: fillable('input[name="name"]'),
  setToHosted: clickable('input[name^="provider-hosting"][value="hosted"]'),
  setToExternal: clickable('input[name^="provider-hosting"][value="external"]'),
  fillInExternalUrl: fillable('input[name="externalUrl"]'),
  fileChange: triggerable('change', 'input[name="hostedFile"]'),
  setChecksumType: fillable('select[name="checksumType"]'),
  fillInChecksum: fillable('input[name="checksum"]'),
  setArchitecture: fillable('select[name="architecture"]'),
  setDefaultForName: clickable('input[name^="architecture-default"]'),
  archErrorField: {
    scope: '.hds-form-error',
    fieldText: attribute('attributeName', 'architecture-error')
  },
  fileErrorField: {
    scope: '.hds-form-error',
    fieldText: attribute('attributeName', 'file-error')
  },
  async chooseFile(file) {
    await this.fileChange({
      files: [file]
    });
  },
  async populate(fixture) {
    if (fixture.externalUrl) {
      await this.setToExternal();
      await this.fillInExternalUrl(fixture.externalUrl);
    } else if (fixture.file) {
      await this.setToHosted();
      await this.chooseFile(fixture.file);
    }
    if (fixture.name) await this.fillInName(fixture.name);
    if (fixture.checksumType) await this.setChecksumType(fixture.checksumType);
    if (fixture.checksum) await this.fillInChecksum(fixture.checksum);
    if (fixture.architecture) await this.setArchitecture(fixture.architecture);
  },
  remove: clickable('.hds-button--color-critical'),
  ...properties
});